import { Input } from '@angular/core';
import { QuestionBaseModel } from './question-base.model';

export class SsnQuestionModel extends QuestionBaseModel<any> {
   
    ssnThreeNumbers:number;
    ssnTwoNumber:number;
    ssnFourNumbers:number;

    constructor(options: {} = {}) {
      super(options);  
      if(options['value']){
        let ssn=options['value'].replace(/-/gi,'').toString();
        this.ssnThreeNumbers=ssn.substr(0,3)
        this.ssnTwoNumber=ssn.substr(3,2)
        this.ssnFourNumbers=ssn.substr(5,4)
      }        
    }
    
  }


// WEBPACK FOOTER //
// ./src/app/shared/models/ssn-question.model.ts